import * as v from "valibot";
import { rpcContract } from "../rpc";

/**
 * Create Stripe checkout session for one-time content purchase
 * Starts the payment flow for a single piece of premium content
 * Returns session details for redirect to Stripe Checkout
 */
export const createOneTimeCheckoutRpcContract = rpcContract({
  name: "create-one-time-checkout",
  paramsSchema: v.object({
    contentType: v.picklist(["post", "link"]),
    contentId: v.string(),
  }),
  resultSchema: v.object({
    sessionId: v.string(),
    url: v.string(),
  }),
});

export type CreateOneTimeCheckoutParams = v.InferOutput<(typeof createOneTimeCheckoutRpcContract)["paramsSchema"]>;
export type CreateOneTimeCheckoutResult = v.InferOutput<(typeof createOneTimeCheckoutRpcContract)["resultSchema"]>;
